// VP-206: HEIC z iPhone'a nie jest renderowany przez przeglądarki ani akceptowany
// przez Meta — konwertujemy do JPEG po stronie klienta, PRZED presigned uploadem
// do S3, żeby cały downstream (podgląd, analiza AI, Meta) widział zwykły JPEG.
// heic2any (wasm libheif) ładowany lazy — bundle rośnie tylko przy pliku HEIC.

const HEIC_MIME_TYPES = new Set(["image/heic", "image/heif"]);
const HEIC_EXTENSION_RE = /\.(heic|heif)$/i;
const JPEG_QUALITY = 0.9;

// iOS Safari potrafi dać puste file.type dla HEIC — dlatego też po rozszerzeniu.
export function isHeicFile(file: File): boolean {
  return HEIC_MIME_TYPES.has(file.type) || HEIC_EXTENSION_RE.test(file.name);
}

export async function convertHeicToJpeg(file: File): Promise<File> {
  const { default: heic2any } = await import("heic2any");
  const converted = await heic2any({ blob: file, toType: "image/jpeg", quality: JPEG_QUALITY });
  const blob = Array.isArray(converted) ? converted[0] : converted;
  const name = HEIC_EXTENSION_RE.test(file.name)
    ? file.name.replace(HEIC_EXTENSION_RE, ".jpg")
    : `${file.name}.jpg`;
  return new File([blob], name, { type: "image/jpeg" });
}
